export default __webpack_public_path__ + "static/media/35.77370c92.jpg";